import {useState, useEffect, useContext} from 'react'
import { UserStoreContext } from '../Contexts/UserStoreContext';
import Axios from 'axios';
import ENVIROMENTS from '../Environment/Configuration.json';

const useFetch = (request) => {
    const [data, setData] = useState(null);
    const[isLoading, setIsLoading] = useState(true);
    const[error, setError] = useState(null);
    
    
    const {is_logged_in, set_is_logged_in,set_user_store, user_store} = useContext(UserStoreContext)
    

    useEffect(()=>{ 
        setError(null)
        setIsLoading(true)
        if(request){
            const url = ENVIROMENTS.baseUrl + '/geniuxmusic/api/delete_account.php';
            let cancel
            Axios({
                method: 'post',
                url: url,
                data: {
                    myuserid: is_logged_in?user_store.user_id:"",
                    mytoken: is_logged_in?user_store.user_token:"",
                },
                cancelToken: new Axios.CancelToken(c => cancel = c),

            })
            
            .then(response=>{
                if(response.data[0] && response.data.length>0){
                    setData(response.data)
                    setIsLoading(false)
                    setError(null);  

                    
                }else{
                    if(response.data.response){
                        if(response.data.response==="credentials_not_provided" || response.data.response==="username_not_found"){
                            setError('not_logged_in');  
                            set_is_logged_in(false)
                            set_user_store(null)
                        }else if(response.data.response==="failed_to_delete"){
                            setError('failed_to_delete');  
                        }else{
                            setError('unknown_err');  
                        }
                    }else{
                        setError('unknown_err');  
                    }
                    setData(null)
                    setIsLoading(false)
                
                }
        
            
            })
            .catch(err=>{
                if(!Axios.isCancel(err)){
                    setError('network_err');
                    setIsLoading(false)
                }
            })
            return () => cancel()
        
        }else{
            setIsLoading(false)
        }
    
    
    },[request])
 
    return {data, isLoading, error}
}

export default useFetch
